module.exports = __webpack_public_path__ + "img/collection-weddingRingsCertificate.96b66d9.jpg";